/**
 * A DataCollection instance for managing player data.
 *
 * @type {webix.DataCollection}
 */
export const players = new webix.DataCollection({});

// FILE DOCUMENTED
